import { render, staticRenderFns } from "./TextsFinished.vue?vue&type=template&id=3a6b6bae&scoped=true&"
import script from "./TextsFinished.vue?vue&type=script&lang=js&"
export * from "./TextsFinished.vue?vue&type=script&lang=js&"
import style0 from "./TextsFinished.vue?vue&type=style&index=0&id=3a6b6bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6b6bae",
  null
  
)

export default component.exports